/**
 * IR-661 Phase 7 Task 12 — PersonalDetails (im_account) sub-form.
 *
 * Backend reality (Task 5, api/ops/serializers_data.py:232-244):
 *   PersonalDetailsUpdateSerializer accepts free-text per Q3a:
 *     firstname, lastname, username, displayname (no underscore!),
 *     shortname, pushname, gender, email_address, languages, education,
 *     location_app
 *
 *   It does NOT have `country` or `bio` columns — those live on
 *   AccountBasicInfo for social_media_account / account types.
 */

export interface PersonalDetailsFormState {
  firstname: string;
  lastname: string;
  username: string;
  displayname: string;
  email_address: string;
}

export function initialPersonalDetails(seed: Record<string, unknown>): PersonalDetailsFormState {
  return {
    firstname: typeof seed.firstname === "string" ? seed.firstname : "",
    lastname: typeof seed.lastname === "string" ? seed.lastname : "",
    username: typeof seed.username === "string" ? seed.username : "",
    displayname: typeof seed.displayname === "string" ? seed.displayname : "",
    email_address: typeof seed.email_address === "string" ? seed.email_address : "",
  };
}

export function diffPersonalDetails(
  form: PersonalDetailsFormState,
  seed: Record<string, unknown>,
): Record<string, unknown> {
  const initial = initialPersonalDetails(seed);
  const out: Record<string, unknown> = {};
  for (const key of Object.keys(form) as Array<keyof PersonalDetailsFormState>) {
    if (form[key] !== initial[key]) {
      out[key] = form[key];
    }
  }
  return out;
}

interface Props {
  form: PersonalDetailsFormState;
  setForm: (next: PersonalDetailsFormState) => void;
}

export function PersonalDetailsForm({ form, setForm }: Props) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <label
        htmlFor="ir661-edit-entity-pd-username"
        style={{ display: "block", fontSize: 12, color: "var(--iris-fg-3)" }}
      >
        Username
        <input
          id="ir661-edit-entity-pd-username"
          className="iris-input"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          style={{ width: "100%", marginTop: 4 }}
        />
      </label>

      <label
        htmlFor="ir661-edit-entity-pd-displayname"
        style={{ display: "block", fontSize: 12, color: "var(--iris-fg-3)" }}
      >
        Displayname
        <input
          id="ir661-edit-entity-pd-displayname"
          className="iris-input"
          value={form.displayname}
          onChange={(e) => setForm({ ...form, displayname: e.target.value })}
          style={{ width: "100%", marginTop: 4 }}
        />
      </label>

      <label
        htmlFor="ir661-edit-entity-pd-firstname"
        style={{ display: "block", fontSize: 12, color: "var(--iris-fg-3)" }}
      >
        First Name
        <input
          id="ir661-edit-entity-pd-firstname"
          className="iris-input"
          value={form.firstname}
          onChange={(e) => setForm({ ...form, firstname: e.target.value })}
          style={{ width: "100%", marginTop: 4 }}
        />
      </label>

      <label
        htmlFor="ir661-edit-entity-pd-lastname"
        style={{ display: "block", fontSize: 12, color: "var(--iris-fg-3)" }}
      >
        Last Name
        <input
          id="ir661-edit-entity-pd-lastname"
          className="iris-input"
          value={form.lastname}
          onChange={(e) => setForm({ ...form, lastname: e.target.value })}
          style={{ width: "100%", marginTop: 4 }}
        />
      </label>

      <label
        htmlFor="ir661-edit-entity-pd-email"
        style={{ display: "block", fontSize: 12, color: "var(--iris-fg-3)" }}
      >
        Email Address
        <input
          id="ir661-edit-entity-pd-email"
          className="iris-input"
          value={form.email_address}
          onChange={(e) => setForm({ ...form, email_address: e.target.value })}
          style={{ width: "100%", marginTop: 4 }}
        />
      </label>
    </div>
  );
}
